var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import pick from 'ramda/src/pick';
import mixpanel from 'root/src/client/logic/analytics/mixpanel';
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest';
import uploadFile from 'root/src/client/util/uploadFile';
import { brandProductTypesEnum } from 'root/src/shared/constants/dropEvent';
import { mixpanelEvents } from 'root/src/shared/constants/mixpanel';
import { rewardEndpointIds } from 'root/src/shared/rewards/constants';
import { cropImageToFile } from 'root/src/client/v2/image/helpers/cropImageToFile';
export const dropUploadCodes = (formData) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const formFile = (_a = formData === null || formData === void 0 ? void 0 : formData.csvCodes) === null || _a === void 0 ? void 0 : _a.file;
    const id = (_b = formData === null || formData === void 0 ? void 0 : formData.id) === null || _b === void 0 ? void 0 : _b.value;
    if (!formFile) {
        throw { csvCodes: 'Codes file is required' };
    }
    const filename = yield uploadFile(formFile, dispatch, 60 * 24 * 3); // 3 days ttl
    const image = yield uploadImage(formData, dispatch);
    const { body, error } = yield dispatch(apiRequest(rewardEndpointIds.SAVE_CODE_REWARDS, Object.assign({ filename, id, image }, pick(['name', 'restrictions'], formData))));
    if (error) {
        throw { csvCodes: error.message };
    }
    mixpanel.track(mixpanelEvents.brandProducts, { productType: brandProductTypesEnum.dropCode });
    mixpanel.people.set_once({ addedBrandProduct: moment().format() });
    return body;
});
function uploadImage(formData, dispatch) {
    return __awaiter(this, void 0, void 0, function* () {
        const imageData = formData === null || formData === void 0 ? void 0 : formData.image;
        if (!imageData) {
            return undefined;
        }
        const { coordinates } = imageData;
        if (!coordinates) {
            return uploadFile(imageData.file, dispatch);
        }
        const croppedImage = yield cropImageToFile({ coordinates, source: imageData.file });
        return uploadFile(croppedImage.file, dispatch);
    });
}
